<template>
    <div class="delivery-detail">
        <!-- begin loading -->
        <div v-if="pageLoading" class="page-loading-container">
            <v-progress-circular
                :size="60"
                :width="5"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <!-- end loading -->

        <!-- begin 商品详情 -->
        <div class="wrapper" v-show="!pageLoading">
            <v-container class="delivery-container">
                <v-layout class="delivery-summary">
                    <div
                        class="cover-container"
                        :class="{ 'only-one-img': delivery.images && delivery.images.length === 1 }"
                        v-if="delivery.images && delivery.images.length"
                    >
                        <v-carousel>
                            <v-carousel-item
                                class="cover"
                                :src="item.url"
                                :key="index"
                                v-for="(item, index) in delivery.images"
                            >
                            </v-carousel-item>
                        </v-carousel>
                    </div>
                    <div class="summary-container">
                        <h1 class="delivery-name">
                            {{delivery.no}}.
                            {{
                                (delivery.commodity_name_json &&
                                    delivery.commodity_name_json[getTranslateIndex]) ||
                                delivery.name
                            }}
                        </h1>
                        <div class="delivery-price">
                            €{{ delivery.price | fixed(2, true) }}
                        </div>
                        <div class="allergen-list">
                            <div
                                class="item"
                                v-for="it in delivery.allergen"
                                :key="it.guid"
                            >
                                <img
                                    style="width:20px;height: 20px;"
                                    :src="it.image"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="summary">
                            {{
                                (delivery.description_json &&
                                    delivery.description_json[getTranslateIndex]) ||
                                delivery.description
                            }}
                        </div>
                    </div>

                    <!-- begin 备注 属性选择 -->
                    <div class="attributes-container">
                        <div class="attributes-title">
                            <div>{{ $t("delivery_detail.remark") }}：</div>
                            <!-- <input placeholder="输入或选择备注" /> -->
                        </div>
                        <div v-for="(cate, cateIndex) in (delivery.attributes_cate || [])" :key="cate.guid">
                            <div class="title">{{ cate.attr_cate_name }}（{{$t(cate.type === 0 ? "unClass.add389" : 'unClass.add392', {num: cate.min_limit})}}）</div>
                            <div class="attributes-content">
                                <div
                                    v-for="(item, index) in cate.attributes"
                                    :key="index"
                                    :class="{ item: true, active: item.check }"
                                    @click="checkAttr(item, cateIndex, index)"
                                >
                                    {{ item.name }}{{ Number(item.price) ? ` €${item.price}` : `` }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- begin 备注 属性选择 -->

                    <!-- begin 选择数量 -->
                    <div
                        class="form-container"
                        v-if="
              delivery.garnish &&
                delivery.garnish.length == 0 &&
                storeInfo.orderScanner == 1
            "
                    >
                        <v-layout
                            class="form-group"
                            v-if="getGoodsNums(delivery.guid) > 0"
                        >
                            <v-btn
                                fab
                                dark
                                outline
                                small
                                color="primary"
                                class="stepper"
                                @click="handleMinusFromCart"
                            >
                                <v-icon dark>remove</v-icon>
                            </v-btn>
                            <v-flex xs2>
                                <div class="goods-num">{{ getGoodsNums(delivery.guid) }}</div>
                            </v-flex>
                            <v-btn
                                fab
                                dark
                                outline
                                small
                                color="primary"
                                class="stepper"
                                @click="handleAddToCart"
                            >
                                <v-icon dark>add</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout
                            class="form-group"
                            v-if="getGoodsNums(delivery.guid) <= 0"
                        >
                            <v-btn
                                fab
                                dark
                                outline
                                small
                                color="primary"
                                class="stepper"
                                @click="handleAddToCart"
                            >
                                <v-icon dark>add</v-icon>
                            </v-btn>
                        </v-layout>
                    </div>
                    <!-- end 选择数量 -->
                </v-layout>
            </v-container>
        </div>
        <!-- end 商品详情 -->

        <div class="bottom-btn" @click="handleBack" v-if="timeout">
            {{
                getGoodsNums(delivery.guid) <= 0
                    ? $t("delivery_detail.back")
                    : $t("delivery_detail.confirm")
            }}
        </div>
    </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {required, integer, minValue} from "vuelidate/lib/validators";
import {mapGetters, mapMutations, mapActions, mapState} from "vuex";
import {fixed} from "../../../utils";
import Store from "@/api/store";

export default {
    mixins: [validationMixin],
    validations: {
        num: {required, integer, minValue: minValue(1)}
    },
    data() {
        return {
            added: false,
            pageLoading: false,
            timeout: false, //设置一个小延时
        };
    },
    mounted() {
        this.getStoreInfo();
        this.initData();
        setTimeout(() => {
            this.timeout = true;
        }, 200)
    },
    computed: {
        ...mapGetters({
            delivery: "currentDelivery"
        }),
        ...mapGetters(["cart", "getTranslateIndex"]),
        ...mapState(["carts", "storeInfo", "buffetRoundSetting", "isBuffet", "myOrder"]),
        getGoodsNums() {
            return (guid) => {
                let num = 0;
                (this.carts || []).map(item => {
                    if(item.guid === guid) num += item.num
                })
                return num;
            }
        },
        existLastIndex() {
            return this.cart.items.findLastIndex(item => item.guid === this.delivery.guid);
        }
    },
    methods: {
        ...mapMutations(["addToCart", "minusFromCart", "setDelivery", "resetCart"]),
        ...mapActions(["getDeliveryDetail", "updateQrcodeCart", "getStoreInfo"]),
        handleAddToCart() {
            if(!this.$analysisRound(this.buffetRoundSetting, [...(this.carts || []), this.delivery], this.myOrder, this.isBuffet)) return ;
            // if(this.delivery.attributes && this.delivery.attributes.length && !(this.delivery.attributes || []).find(item=>item.check)){
            //     alert(this.$t('common.requiredAttr'));
            //     return ;
            // }
            if(this.delivery.attributes_cate && this.delivery.attributes_cate.length){
                let flag = true, selected = [];
                this.delivery.attributes_cate.forEach(cate=>{
                    if(cate.attributes){
                        cate.attributes.forEach(attr=>{
                            if(attr.check){
                                selected.push(attr.guid);
                            }
                        })
                    }
                })
                this.delivery.attributes_cate.forEach(item=>{
                    if(!this.$allowAddAttr(this.delivery.attributes_cate, selected, null, item)) flag = false;
                });
                if(!flag) return ;
            }
            this.addToCart({
                num: 1,
                guid: this.delivery.guid,
                index: this.existLastIndex === -1 ? undefined : this.existLastIndex
            });
            this.updateQrcodeCart();
        },
        handleMinusFromCart() {
            this.minusFromCart({
                num: 1,
                guid: this.delivery.guid,
                index: this.existLastIndex === -1 ? undefined : this.existLastIndex
            });
            this.updateQrcodeCart();
        },
        async initData() {
            this.pageLoading = true;
            const guid = this.$route.params.id;
            await this.getDeliveryDetail({guid});
            this.pageLoading = false;
        },

        handleBack() {
            this.updateQrcodeCart();
            this.$router.back();
        },

        /**
         * 选择属性标签
         */
        checkAttr(item, cateIndex, index) {
            let attributes = this.delivery.attributes_cate;

            let carts = this.carts, selected = [];
            this.delivery.attributes_cate.forEach(cate=>{
                if(cate.attributes){
                    cate.attributes.forEach(attr=>{
                        if(attr.check){
                            selected.push(attr.guid);
                        }
                    })
                }
            })
            if(!this.delivery.attributes_cate[cateIndex].attributes[index].check){
                if(!this.$allowAddAttr(attributes, selected, item.guid)) return ;
            }

            this.delivery.attributes_cate[cateIndex].attributes[index].check = !this.delivery.attributes_cate[cateIndex].attributes[index].check;

            let cart_attributes = [];
            this.delivery.attributes_cate.forEach(cate=>{
                if(cate.attributes){
                    cate.attributes.forEach(attr=>{
                        if(attr.check){
                            cart_attributes.push(attr.guid);
                        }
                    })
                }
            })

            carts.map((item1, index) => {
                if (item1.guid == this.delivery.guid) {
                    carts[index].attributes = cart_attributes;
                }
            });

            this.resetCart(carts);

            this.setDelivery({
                ...this.delivery,
                attributes
            });
        }
    },
    filters: {
        fixed
    }
};
</script>

<style scoped lang="sass" src="./delivery-detail.sass"></style>
